module.exports = __webpack_public_path__ + "static/media/seat-outlet-symbol.9d815987.svg";